// @flow
import React, { Children, type Node } from 'react';
import classnames from 'classnames';

const SIZE_CLASSES = {
  full: 'max-w-none',
  large: 'max-w-site',
  medium: 'max-w-site-medium',
  small: 'max-w-site-small',
  mini: 'max-w-site-mini',
};

type Props = {
  bgColor?: Colors,
  children: Node,
  className?: string,
  dataTestId?: string,
  hasBorders?: boolean,
  hasBottomShadow?: boolean,
  hasShadowOutset?: boolean,
  hasTopShadow?: boolean,
  id?: string,
  isWide?: boolean,
  size?: 'mini' | 'small' | 'medium' | 'large' | 'full',
};

export function SiteContainer(props: Props) {
  const {
    bgColor = 'transparent',
    children,
    className,
    dataTestId,
    hasBorders,
    hasBottomShadow,
    hasShadowOutset,
    hasTopShadow,
    id,
    isWide,
    size = 'large',
  } = props;

  if (!Children.count(children)) {
    return null;
  }

  return isWide ? (
    children
  ) : (
    <div
      className={classnames(className, 'site-container px-5 relative w-full', {
        [`bg-${bgColor}`]: bgColor,
        'border-b-1 border-t-1 border-gray-light': hasBorders,
        'shadow-md': hasShadowOutset,
        'shadow-inner-top': hasTopShadow,
        'shadow-inner-bottom': hasBottomShadow,
      })}
      // $FlowFixMe
      {...(id ? { id } : null)}
      {...(dataTestId ? { 'data-testid': dataTestId } : null)}
    >
      <div
        data-testid="SiteContainer-inner"
        className={classnames('site-container-inner m-auto', SIZE_CLASSES[size])}
      >
        {children}
      </div>
    </div>
  );
}
